<template>
    <c-modal :hide-footer="!!selectedEffect" :value="isOpen" title="Image Effects" size="xl" @closed="handleClose">
        <image-effects-properties-modals-add-header v-if="!selectedEffect" />
        <image-effects-properties-modals-add-body v-if="!selectedEffect" />
        <image-effect-selected-body v-if="selectedEffect" :effect="selectedEffect" @update="handleUpdate" />
        <template #modal-footer>
            <div class="d-flex justify-content-end">
                <c-button text="Cancel" variant="secondary" @click="handleClose" />
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
import { watch, computed } from 'vue';
import store from '@/store';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';

import ImageEffectsPropertiesModalsAddHeader from './components/header/ImageEffectsPropertiesCreateHeader.vue';
import ImageEffectsPropertiesModalsAddBody from './components/body/ImageEffectsPropertiesCreateBody.vue';
import ImageEffectSelectedBody from './components/body/ImageEffectSelectedBody.vue';
import { createEffectFromPreset } from '../../utils/effectCreators';
import { ImageEffectType } from '@/typings/customilyElements/imageEffectType';

const emit = defineEmits<{
    (event: 'update', value: ImageEffectType, newData?: ImageEffectType): void;
}>();

const isOpen = computed(() => {
    return store.state.imageEffectsProperties?.modalAddIsOpen || false;
});
const selectedEffect = computed(() => {
    return store.state.imageEffectsProperties?.selectedImageEffect;
});

const handleUpdate = (newData: ImageEffectType, id?: string) => {
    let effect;
    if (!selectedEffect.value?.formData) {
        const presetSelected = selectedEffect.value?.presets?.find((preset) => preset.id === id);
        if (presetSelected) effect = createEffectFromPreset(presetSelected);
        store.dispatch('imageEffectsProperties/addImageEffect', effect);
    } else {
        effect = selectedEffect.value.formData;
    }
    if (effect) emit('update', effect, newData);
};

const handleClose = () => {
    store?.dispatch('imageEffectsProperties/closeAddModal');
};

const resetForm = () => {
    store.dispatch('imageEffectsProperties/resetModalState');
};

watch(
    () => isOpen.value,
    () => {
        if (!isOpen.value) {
            resetForm();
        }
    }
);
</script>
